import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';
import PreviewDividends from './Dividends/preview';
import PreviewGeneralSpouseIncome from './General/preview';
import PreviewInterest from './Interest/preview';
import PreviewPension from './Pension/preview';
import PreviewWages from './Wages/preview';

export interface IPreviewSpouseIncomeProps {}

export default function PreviewSpouseIncome(props: IPreviewSpouseIncomeProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Spouse Income">
        {routes.spouseIncome.dividends && <PreviewDividends />}
        <PreviewGeneralSpouseIncome />
        {routes.spouseIncome.interest && <PreviewInterest />}
        {routes.spouseIncome.pension && <PreviewPension />}
        {routes.spouseIncome.wages && <PreviewWages />}
      </PreviewExpandable>
    </>
  );
}
